const baseState = {
    tokensList: [],
    sortByField: "",
	sortFromTo: "asc"
}

const tokensReducer = (state = baseState, { type, payload }) => {

    switch (type) {
    	case "SET_TOKENS_LIST": {
			return {
				...state,
				tokensList: payload
			}
		}

		case "CLEAR_TOKENS_LIST": {
			return {
				...state,
				tokensList: []
			}
		}

		case "SET_TOKENS_SORT_BY_FIELD": {
			return {
				...state,
				sortByField: payload
			}
		}

		case "SET_TOKENS_SORT_FROM_TO": {
			return {
				...state,
				sortFromTo: payload
			}
		}

        default:
            return state;
    }
}

export default tokensReducer